import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { PageLoader, useMinLoading } from "@/components/Preloader";
import api from "@/lib/api";
import { Article } from "@/lib/types";
import { ArticleCard } from "@/components/ArticleCard";
import { Seo } from "@/components/Seo";

export default function Originals() {
  const [limit, setLimit] = useState(18);
  const { data, isLoading } = useQuery({
    queryKey: ["originals-page", limit],
    queryFn: async () => (await api.get("/articles", {
      params: { content_type: "deep_dive,weekly_recap,author", limit },
    })).data,
  });
  const showLoader = useMinLoading(isLoading);
  if (showLoader) return <PageLoader />;
  const items: Article[] = data?.items || [];
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-14" data-testid="originals-page">
      <Seo title="NewsLayer Originals — Original Reporting & Analysis"
        description="Original reporting, exclusive analysis and research from the NewsLayer Intelligence Desk." />
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A78BFA]">From the NewsLayer desk</p>
      <h1 className="font-heading font-black text-white text-3xl sm:text-4xl tracking-tight mt-2">NewsLayer Originals</h1>
      <p className="text-gray-500 text-sm mt-2 max-w-xl">Original reporting. Exclusive analysis. NewsLayer intelligence.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-8">
        {items.map((a) => <ArticleCard key={a.slug} article={a} />)}
      </div>
      {items.length === 0 && (
        <p className="text-gray-500 text-sm mt-10">No originals published yet — check back soon.</p>
      )}
      {items.length >= limit && limit < 48 && (
        <div className="text-center mt-8">
          <button onClick={() => setLimit((l) => Math.min(48, l + 18))} data-testid="originals-load-more"
            className="border border-white/15 hover:border-[#7C3AED] text-gray-300 hover:text-white rounded-lg px-6 py-2.5 text-sm font-semibold transition-colors">
            Load more
          </button>
        </div>
      )}
    </div>
  );
}
